export const STAFF_TOKEN_KEY = 'medical_staff_token'
export const DOCTOR_TOKEN_KEY = 'medical_doctor_token'
export const DOCTOR_EMAIL = 'medical_doctor_email'
export const CHECK_DOCTOR_CERT = 'medical_checked_certificate'
export const STAFF_EMAIL = 'medical_staff_email'
export const CART_TOKEN_KEY = 'cart_items'
export const REGULAR_SHIFT_DOCTOR = 'REGULAR_SHIFT_DOCTOR'
export const PERMANENT_DOCTOR = 'PERMANENT_DOCTOR'
export const GUARANTEE_SHIFT_CLINIC_NAME = '法人都合 保証シフト'
export const GUARANTEE_SHIFT_DOCTOR_LABEL = '実勤務なし（給与保証）'

const normalizeGuaranteeShiftClinicName = clinicName =>
  (clinicName || '').replace(/\s/g, '')

export const isGuaranteeShiftClinicName = clinicName =>
  normalizeGuaranteeShiftClinicName(clinicName) ===
  normalizeGuaranteeShiftClinicName(GUARANTEE_SHIFT_CLINIC_NAME)

export const STAFF_MOVING_EXPENSES_SPECIAL_CLINIC_NAMES = [
  '院外勤務（小児科）',
  '院外勤務（内科）',
  '医師会',
  '医師会・嘱託医業務（小児科）',
  '医師会・嘱託医業務（内科）',
]

export const isStaffMovingExpensesClinicOption = clinic =>
  !isGuaranteeShiftClinicName(clinic?.name) &&
  (clinic?.isPublished === true ||
    STAFF_MOVING_EXPENSES_SPECIAL_CLINIC_NAMES.includes(clinic?.name))

export const CUSTOM_MODAL = [
  'CreateMovingExpenses',
  'MovingExpensesOtherDetail',
  'MovingExpensesRegistrationDetail',
  'DetailOfIncentives',
  'DetailIncentiveSetting',
  'CreateIncentiveSetting',
  'MovingExpensesRegistrationCreate',
  // 'AcceptedWorkScheduleOverTime',
  'WorkScheduleOverTimeDetail',
  'Categorys',
  'CreateDoctorHourlyWage',
  'MovingExpensesAddSetting',
  'MovingExpenseDetailSetting',
]
export const SMALL_MODAL = [
  'DetailWaitingRecruitment',
  'CreateWaitingRecruitment',
]
export const COLORS = {
  normal: '#fa5a5a',
  success: '#34a835',
  warning: '#daefff',
  alert: '#e91224',
  selected: '#f03a6c',
  canceled: '#818c92d0',
  fixed: '#ffffff',
  fixedFulltime: '#ffffcc',
}
export const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
export const phoneFirstRegExp = /^([0-9]{3})$/
export const phoneSecondRegExp = /^([0-9]{4})$/
export const phoneThirdRegExp = /^([0-9]{4})$/

export const ACCEPT_FILE_IMAGE = ['image/jpeg', 'image/png']

export const MAX_HOURLY_WAGE = 100000
export const INITIAL_DEPLOYMENT_DATE = '2019-12-31T15:00:00.000Z'

export const ACCEPT_FILE_EXTENSIONS = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/zip',
  'application/msword',
  'application/vnd.ms-excel',
  '.docx',
  '.doc',
  '.xlsx',
  '.xls',
]

export const ACCEPT_IMAGE_EXTENSIONS = ['image/jpeg', 'image/png']

export const MAX_FILE_SIZE = 10485760

export const ENUM_AVAILABLE_SHIFT = 'AvailableShift'
export const ENUM_ACCEPTED_WS = 'AcceptedWorkSchedule'
export const ENUM_NOT_ACCEPTED_WS = 'NotAcceptedWorkSchedule'
export const ENUM_CANCELED_WS = 'CanceledWorkSchedule'
export const ENUM_FIXED_WS = 'FixSchedule'
export const ENUM_ASSIGNSCHEDULE = 'AssignSchedule'
export const ENUM_UNCONFIRMED_SHIFT = 'UnconfirmedShift'
export const ENUM_MASS_RECRUITMENT = 'MassRecruitment'

export const SHIFT_FORM_STEP = 1

export const MAX_NAME_LENGTH = 25
export const KATAKANA_REG_EXP = /^[\u30A0-\u30FF]+$/
export const NAME_REG_EXP = /^[^"±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,0-9\uff01-\uff5e\uff5f-\uff9f\u3000-\u3004\u3006-\u3030\u3036-\u303A\u303C-\u303F]{0,}$/

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY
const GEOCODE_API_KEY = process.env.REACT_APP_GEOCODE_API_KEY

const CALENDAR_ID = 'ja.japanese.official%23holiday@group.v.calendar.google.com'

export const HOLIDAY_URL = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${GOOGLE_API_KEY}`
export const GEOCODE_URL = `https://maps.googleapis.com/maps/api/geocode/json?key=${GEOCODE_API_KEY}`

export const DOCTOR_STATUSES = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
}
export const STAFF_STATUS = {
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
}
export const HOURLY_WAGE = 'hourlyWage'
export const ACCEPTED = 'ACCEPTED'
export const REJECTED = 'REJECTED'
export const WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL'
export const UPDATE = 'UPDATE'
export const HOURLY_WAGE_ID = 'hourlyWageID'
export const TYPE_CREATE = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
}
export const SHCEDULE_SHIFT_ACTION = {
  DELETE_ALL: 'DELETE_ALL',
  UPDATE_ALL: 'UPDATE_ALL',
  UPDATE_PARTIAL: 'UPDATE_PARTIAL',
}

export const DAY_IN_WEEK = {
  MONTHDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
}

// INQUIRY
export const INQUIRY_TYPES = {
  CHAT: 'CHAT',
  SEARCH: 'SEARCH',
}

export const INQUIRY_SENDER = {
  STAFF: 'STAFF',
  DOCTOR: 'DOCTOR',
}

export const SCROLL_TYPE = {
  SCROLL_UP: 'SCROLL_UP',
  SCROLL_DOWN: 'SCROLL_DOWN',
}

export const ROW_PER_PAGE = 10
export const MOVING_EXPENSE_TYPES = {
  OTHER: 'OTHER',
  TAXI: 'TAXI',
  CAR: 'CAR',
  BASE_TRANSFER: 'BASE_TRANSFER',
  PARKING_FREE: 'PARKING_FREE',
  HIGHWAY: 'HIGHWAY',
  ACCOMMONDATION: 'ACCOMMONDATION',
  TRANSPORTATION: 'TRANSPORTATION',
  TRANSPORTATIONCAR: 'TRANSPORTATIONCAR',
}

export const ACTION_TYPE = {
  DELETE: 'DELETE',
  RESTORE_DELETE: 'RESTORE_DELETE',
}
export const IMAGE_ERROR =
  'data:image/png;base64,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'

export const objectTargetConstant = {
  NEW: 'NEW_DOCTOR',
  SET_FOR_EACH_DOCTOR: 'SPECIFY_DOCTORS',
  SET_FOR_ALL_DOCTOR: 'ALL_DOCTORS',
  SET_FOR_EACH_WORKPARTTEN: 'WORK_PATTERN_APPLIED',
}

export const INCENTIVE_TYPE = {
  NORMAL_INCENTIVE: 'NORMAL_INCENTIVE',
  NUMBER_INCENTIVE: 'NUMBER_INCENTIVE',
  BEYOND_EIGHT_INCENTIVE: 'BEYOND_EIGHT_INCENTIVE',
  TIME_INCENTIVE: 'TIME_INCENTIVE',
  SATISFACTION_INCENTIVE: 'SATISFACTION_INCENTIVE',
}
export const CATEGORY_TRANSPORT = {
  TRANFFIC_FEE: 'TRANFFIC_FEE',
  RECURRING_TRAVEL_FEE: 'RECURRING_TRAVEL_FEE',
  CLINIC_TRANFFIC_FEE: 'CLINIC_TRANFFIC_FEE',
}
export const DEFAULT_HOURLY_WAGE_ACTION = {
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
  CREATE: 'CREATE',
}

export const TRANSPORTATION_TYPE_SETTINGS_ACTION = {
  DELETE: 'delete',
  UPDATE: 'update',
}

export const HOURLY_WAGE_LIST = [
  { label: '指定なし', value: null },
  { label: '3万円以上', value: '30000' },
  { label: '4万円以上', value: '40000' },
  { label: '5万円以上', value: '50000' },
  { label: '6万円以上', value: '60000' },
  { label: '7万円以上', value: '70000' },
  { label: '8万円以上', value: '80000' },
  { label: '9万円以上', value: '90000' },
  { label: '10万円以上', value: '100000' },
  { label: '11万円以上', value: '110000' },
  { label: '12万円以上', value: '120000' },
  { label: '13万円以上', value: '130000' },
  { label: '14万円以上', value: '140000' },
  { label: '15万円以上', value: '150000' },
]
export const START_TIME_DEFAULT_MORNING = `2021-10-10T09:00:00.000Z`
export const END_TIME_DEFAULT_MORNING = `2021-10-10T13:00:00.000Z`
export const START_TIME_DEFAULT_AFTERNOON = `2021-10-10T15:00:00.000Z`
export const END_TIME_DEFAULT_AFTERNOON = `2021-10-10T21:00:00.000Z`
export const FORMAT_DATE_CLINIC_TIME_WORK = 'YYYY-MM-DD'
export const FORMAT_TIME_NOT_UTC = 'YYYY-MM-DDTHH:mm:ss'
export const PROVINCES = [
  {
    id: 1,
    name_ja: '北海道',
    name_en: 'Hokkaido',
  },
  {
    id: 2,
    name_ja: '青森県',
    name_en: 'Aomori',
  },
  {
    id: 3,
    name_ja: '岩手県',
    name_en: 'Iwate',
  },
  {
    id: 4,
    name_ja: '宮城県',
    name_en: 'Miyagi',
  },
  {
    id: 5,
    name_ja: '秋田県',
    name_en: 'Akita',
  },
  {
    id: 6,
    name_ja: '山形県',
    name_en: 'Yamagata',
  },
  {
    id: 7,
    name_ja: '福島県',
    name_en: 'Fukushima',
  },
  {
    id: 8,
    name_ja: '茨城県',
    name_en: 'Ibaraki',
  },
  {
    id: 9,
    name_ja: '栃木県',
    name_en: 'Tochigi',
  },
  {
    id: 10,
    name_ja: '群馬県',
    name_en: 'Gunma',
  },
  {
    id: 11,
    name_ja: '埼玉県',
    name_en: 'Saitama',
  },
  {
    id: 12,
    name_ja: '千葉県',
    name_en: 'Chiba',
  },
  {
    id: 13,
    name_ja: '東京都',
    name_en: 'Tokyo',
  },
  {
    id: 14,
    name_ja: '神奈川県',
    name_en: 'Kanagawa',
  },
  {
    id: 15,
    name_ja: '新潟県',
    name_en: 'Niigata',
  },
  {
    id: 16,
    name_ja: '富山県',
    name_en: 'Toyama',
  },
  {
    id: 17,
    name_ja: '石川県',
    name_en: 'Ishikawa',
  },
  {
    id: 18,
    name_ja: '福井県',
    name_en: 'Fukui',
  },
  {
    id: 19,
    name_ja: '山梨県',
    name_en: 'Yamanashi',
  },
  {
    id: 20,
    name_ja: '長野県',
    name_en: 'Nagano',
  },
  {
    id: 21,
    name_ja: '岐阜県',
    name_en: 'Gifu',
  },
  {
    id: 22,
    name_ja: '静岡県',
    name_en: 'Shizuoka',
  },
  {
    id: 23,
    name_ja: '愛知県',
    name_en: 'Aichi',
  },
  {
    id: 24,
    name_ja: '三重県',
    name_en: 'Mie',
  },
  {
    id: 25,
    name_ja: '滋賀県',
    name_en: 'Shiga',
  },
  {
    id: 26,
    name_ja: '京都府',
    name_en: 'Kyoto',
  },
  {
    id: 27,
    name_ja: '大阪府',
    name_en: 'Osaka',
  },
  {
    id: 28,
    name_ja: '兵庫県',
    name_en: 'Hyogo',
  },
  {
    id: 29,
    name_ja: '奈良県',
    name_en: 'Nara',
  },
  {
    id: 30,
    name_ja: '和歌山県',
    name_en: 'Wakayama',
  },
  {
    id: 31,
    name_ja: '鳥取県',
    name_en: 'Tottori',
  },
  {
    id: 32,
    name_ja: '島根県',
    name_en: 'Shimane',
  },
  {
    id: 33,
    name_ja: '岡山県',
    name_en: 'Okayama',
  },
  {
    id: 34,
    name_ja: '広島県',
    name_en: 'Hiroshima',
  },
  {
    id: 35,
    name_ja: '山口県',
    name_en: 'Yamaguchi',
  },
  {
    id: 36,
    name_ja: '徳島県',
    name_en: 'Tokushima',
  },
  {
    id: 37,
    name_ja: '香川県',
    name_en: 'Kagawa',
  },
  {
    id: 38,
    name_ja: '愛媛県',
    name_en: 'Ehime',
  },
  {
    id: 39,
    name_ja: '高知県',
    name_en: 'Kōchi',
  },
  {
    id: 40,
    name_ja: '福岡県',
    name_en: 'Fukuoka',
  },
  {
    id: 41,
    name_ja: '佐賀県',
    name_en: 'Saga',
  },
  {
    id: 42,
    name_ja: '長崎県',
    name_en: 'Nagasaki',
  },
  {
    id: 43,
    name_ja: '熊本県',
    name_en: 'Kumamoto',
  },
  {
    id: 44,
    name_ja: '大分県',
    name_en: 'Oita',
  },
  {
    id: 45,
    name_ja: '宮崎県',
    name_en: 'Miyazaki',
  },
  {
    id: 46,
    name_ja: '鹿児島県',
    name_en: 'Kagoshima',
  },
  {
    id: 47,
    name_ja: '沖縄県',
    name_en: 'Okinawa',
  },
]

export const DOWNLOAD_CSV_DOCTOR_MONTHLY_TRANSPORT_EXPENSES =
  'DOCTOR_MONTHLY_TRANSPORT_EXPENSES'
export const DOWNLOAD_CSV_DOCTOR_DAILY_TRANSPORT_EXPENSES =
  'DOCTOR_DAILY_TRANSPORT_EXPENSES'
export const DOWNLOAD_CSV_MONTHLY_AVAILABLE_SHIFT = 'MONTHLY_AVAILABLE_SHIFT'
export const DOWNLOAD_CSV_UNCONFIRM_SHIFT = 'UNCONFIRM_SHIFT'
export const DOWNLOAD_CSV_MASS_RECRUITMENT = 'MASS_RECRUITMENT'
export const DOWNLOAD_CSV_WORK_SCHEDULE_LIST = 'WORK_SCHEDULE_LIST'
export const DOWNLOAD_CSV_ACCEPTED_WORK_SCHEDULE_LIST =
  'ACCEPTED_WORK_SCHEDULE_LIST'
export const DOWNLOAD_CSV_MONTHLY_WORKSCHEDULE_BY_TIME_SHIFT =
  'DOWNLOAD_CSV_MONTHLY_WORKSCHEDULE_BY_TIME_SHIFT'
export const DOWNLOAD_CSV_ISSHIN_WORK_SCHEDULE_LIST =
  'ISSHIN_WORK_SCHEDULE_LIST'
export const DOWNLOAD_CSV_DOCTOR_INFO = 'DOCTOR_INFO'
export const DOWNLOAD_CSV_DOCTOR_NUMBER_MANAGE = 'DOCTOR_NUMBER_MANAGE'
export const DOWNLOAD_CSV_DOCTOR_PENDING = 'DOCTOR_PENDING'
export const DOWNLOAD_CSV_STAFF_LIST = 'STAFF_LIST'
export const DOWNLOAD_CSV_DOCTOR_LOG_HISTORY = 'DOCTOR_LOG_HISTORY'
export const DOWNLOAD_CSV_LIST_MOVING_EXPENSES = 'LIST_MOVING_EXPENSES'
export const DOWNLOAD_CSV_MOVING_EXPENSES_REGISTRATION =
  'MOVING_EXPENSES_REGISTRATION'
export const DOWNLOAD_CSV_MONTHLY_DOCTOR_SALARY_CONFIRMATION =
  'MONTHLY_DOCTOR_SALARY_CONFIRMATION'
export const DOWNLOAD_CSV_INCENTIVE_LIST = 'INCENTIVE_LIST'
export const DOWNLOAD_HOURLY_WAGE_CHANGE_RESERVATION =
  'HOURLY_WAGE_CHANGE_RESERVATION '
export const DOWNLOAD_CSV_UNFILLED_TIME_WORK_SCHEDULE =
  'UNFILLED_TIME_WORK_SCHEDULE'
export const DOWNLOAD_CSV_DOCTOR_LAST_WORKDAY =
  'DOWNLOAD_CSV_DOCTOR_LAST_WORKDAY'
export const DOWNLOAD_CSV_MONTHLY_RECRUITMENT_SHIFT =
  'DOWNLOAD_CSV_MONTHLY_RECRUITMENT_SHIFT'
export const DOWNLOAD_CSV_DOCTOR_INFO_CONSULTATION_TIME =
  'DOWNLOAD_CSV_DOCTOR_INFO_CONSULTATION_TIME'
export const DOWNLOAD_CSV_CANCEL_SHIFT = 'CANCEL_SHIFT'
export const INSURANCE_DOCTOR_REGISTRATION = 'INSURANCE_DOCTOR_REGISTRATION'
